import { ContextManager } from './utils/contextmanager';
import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { RouterDataModelProps, RouterBuilderImpl } from './utils/routerbuilder';
import { PropertyImpl } from './utils/property/property';
import { LanguageConst } from './utils/resources/languageconst';
import { ThemeConst } from './utils/resources/themeconst';
import { createBrowserHistory } from 'history';
import { ApplicationBuild, ApplicationBuildTypes } from './utils/property/applicationbuild';
import { PropertyReader } from './utils/property/propertyreader';
import { ErrorComponent } from './ui/components/navigation/error/errorcomponent';
import { RoutingFeatures } from './ui/components/navigation/routingfeature';
import { MainComponent } from './maincomponent';

export function initMain() {
  // console.log = () => {

  // };

  // console.error = () => {

  // };

  // number:9263653978
  // password: Th@ndar1


  ApplicationBuild.setBuild(ApplicationBuildTypes.PRODUCTION);
  try {
    new PropertyReader().readProperty("properties.json", "application/json",
      {
        onFailure: () => {
          let history = createBrowserHistory();
          history.push("/crbt-web-portal/" + RoutingFeatures.ERROR);
          ReactDOM.render(
            <ErrorComponent context={ContextManager.getContext()} />,
            document.getElementById('root') as HTMLElement
          );

          //  window.location.reload(false);
        },
        onSuccess: (propertiesData: any) => {
          ContextManager.createContext(createRouterProps(propertiesData.properties), () => {
            ReactDOM.render(
              <MainComponent baseContext={ContextManager.getContext()} />,
              document.getElementById('root') as HTMLElement);
          });

          // setTimeout(() => {

          //    );
          // }, 2000);
        }
      });
  }
  catch (e) {
    let history = createBrowserHistory();
    history.push("/crbt-web-portal/" + RoutingFeatures.ERROR);
    ReactDOM.render(
      <ErrorComponent context={ContextManager.getContext()} />,
      document.getElementById('root') as HTMLElement
    );

    //  window.location.reload(false);
  }
}

function createRouterProps(propertiesData: any): RouterDataModelProps {
  let property = new PropertyImpl();
  property.setProperty(propertiesData);

  return new RouterBuilderImpl()
    .setCurrentLanguage(LanguageConst.ENGLISH)
    .setCurrentTheme(ThemeConst.Dark)
    .setRouterHistory(createBrowserHistory(), "/crbt-web-portal")
    .setProperty(property)
    .build();
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/main.tsx